import React, {useState, useEffect} from 'react'
import LineInputSelect from '../../../../../../../components/Inputs/LineInputSelect/LineInputSelect'
import { formData } from './data'
import { Grid } from '@material-ui/core'
import SimpleDialog from '../../../../../../../components/Modals/SimpleDialog'
import { request_add_doctor2hospital } from '../../../requests'
//import { request_add_contact, request_update_contact } from '../../requests'

const AddDoctorModal = props => {

    const {onClose, onUpdateContacts, origin, options, hospital_id, onUpdateData} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [issending, setIsSending] = useState(false)
    const [error, setError] = useState(null)


    const data = {issending:issending, error:error}

    const  onInputChange = (data) => {
        let temp = {...form}
        temp[data.config.id] = {...data}
        setForm(temp)
    }

    const onSubmit = async() => {
        let data2send = {}
        let isValid = true
        Object.keys(form).forEach(item => {
            if(form[item].isValid && form[item].isVisited) data2send = {...data2send, [item]:form[item].value}
            if(form[item].isRequired && !form[item].isValid) isValid = false
        })
        if(isValid){
            setError(null)
            setIsSending(true)
            try {
                data2send = {...data2send, hospital_id:hospital_id}
                const doctors = await request_add_doctor2hospital(hospital_id, data2send)
                onUpdateData(doctors)
            } catch (error) {
                setError('Hubo un error, intente de nuevo')
            }
            setIsSending(false)
        }else{
            setError('Llene los datos faltantes')
        }
    }

    form.doctor_id.options = [...options]

    return(
        <SimpleDialog
            title='Agregar doctor'
            data={data}
            onClose={onClose}
            onSubmit={onSubmit}
        >
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LineInputSelect data={form.doctor_id} onChange={onInputChange}/>
                    </Grid>
                </Grid>
            </div>
        </SimpleDialog>
    )
}

export default AddDoctorModal